import { render, staticRenderFns } from "./SovremennayaNevrologiya.vue?vue&type=template&id=5d4eb7a0&scoped=true"
import script from "./SovremennayaNevrologiya.vue?vue&type=script&lang=js"
export * from "./SovremennayaNevrologiya.vue?vue&type=script&lang=js"
import style0 from "./SovremennayaNevrologiya.vue?vue&type=style&index=0&id=5d4eb7a0&prod&lang=scss&scoped=true"
import style1 from "./SovremennayaNevrologiya.vue?vue&type=style&index=1&id=5d4eb7a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4eb7a0",
  null
  
)

export default component.exports